// extracted by mini-css-extract-plugin
module.exports = {"editor":"tag_editor__3E-hQ","active":"tag_active__OMyAz"};